// Pure drag-drop helpers for cards/studyPlan/StudyPlanEdit. Mirror
// of lf_fe/src/lib/parent/dragDrop.js (see #136) for the student app.
//
// test-yted's editor only renders a single lesson list (no side-by-
// side preview pane), so the lesson helper is the trivial single-list
// reorder. The topic helper handles cross-lesson moves within the
// single list. Both copy every level they touch so the inputs are
// never mutated — the inline versions in StudyPlanEdit called .splice
// directly on closure-captured state arrays, which works under
// React 17 batching but is technically wrong.
//
// The drop ``result`` shape matches react-beautiful-dnd:
//   { source: { droppableId, index }, destination: { droppableId, index } | null }
// For topics, droppableId is "<topics>:<lessonIndex>".

export function applyLessonReorder(result, lessons) {
    const { source, destination } = result;
    const next = [...lessons];
    const [removed] = next.splice(source.index, 1);
    if (destination) {
        next.splice(destination.index, 0, removed);
    }
    return next;
}

export function applyTopicDrag(result, lessons) {
    const { source, destination } = result;
    const sourceLessonIndex = parseInt(source.droppableId.split(':')[1], 10);
    const sourceTopicIndex = source.index;

    // Drop-outside: remove the topic.
    if (!destination) {
        const next = [...lessons];
        const lesson = { ...next[sourceLessonIndex] };
        lesson.topics = [...lesson.topics];
        lesson.topics.splice(sourceTopicIndex, 1);
        next[sourceLessonIndex] = lesson;
        return next;
    }

    const destLessonIndex = parseInt(destination.droppableId.split(':')[1], 10);
    const destTopicIndex = destination.index;

    if (sourceLessonIndex === destLessonIndex) {
        const next = [...lessons];
        const lesson = { ...next[sourceLessonIndex] };
        lesson.topics = [...lesson.topics];
        const [moved] = lesson.topics.splice(sourceTopicIndex, 1);
        lesson.topics.splice(destTopicIndex, 0, moved);
        next[sourceLessonIndex] = lesson;
        return next;
    }

    const next = [...lessons];
    const srcLesson = { ...next[sourceLessonIndex] };
    srcLesson.topics = [...srcLesson.topics];
    const [moved] = srcLesson.topics.splice(sourceTopicIndex, 1);
    next[sourceLessonIndex] = srcLesson;

    const dstLesson = { ...next[destLessonIndex] };
    dstLesson.topics = [...dstLesson.topics];
    dstLesson.topics.splice(destTopicIndex, 0, moved);
    next[destLessonIndex] = dstLesson;

    return next;
}
